import React from "react";

const Systeminnstillinger = () => {
    return Systeminnstillinger = () => {
        <div>
            <h1>Systeminnstillingere</h1>
            <p>Velkommen til systeminnstillinger!</p>
        </div>
    }
};

export default Systeminnstillinger;